import { useState } from "react";
import SelectMore from "../../../../../components/SelectMore";
import CleanCache from "./cleanCache";
import NoCacheDomains from "./noCacheDomains";
import CacheUse from "./cacheUse";
import CleanCacheURL from "./cleanCacheUrl";

const userType = JSON.parse(localStorage.getItem("user"))?.type;

const options = [
  {
    name: "domain.no_cache",
    value: "domain"
  },
  {
    name: "domain.cache_use",
    value: "cache_use"
  },
  ...(userType == 0) ? [{ name: "domain.cache_cleaning", value: "cache" }] : [],
  ...(userType == 0) ? [{ name: "domain.cache_uri_cleaning", value: "cache_uri" }] : [],
];

export default function DomainSelectMore({ domain }) {
  const [openModal, setOpenModal] = useState("");

  const handleOpenModal = (name) => {
    setOpenModal(name);
  }

  return (
     <>
       <SelectMore
          options={options}
          openModal={openModal}
          handleOpenModal={handleOpenModal}
       />

       {openModal === "cache"
          ? (
             <CleanCache
                domain={domain}
                setOpen={setOpenModal}
             />
          )
          : null
       }

       {openModal === "domain"
          ? (
             <NoCacheDomains
                domain={domain}
                setOpen={setOpenModal}
             />
          )
          : null
       }

       {openModal === "cache_use"
          ? (
             <CacheUse
                domain={domain}
                setOpen={setOpenModal}
             />
          )
          : null
       }

       {openModal === "cache_uri"
          ? (
             <CleanCacheURL
                domain={domain}
                setOpen={setOpenModal}
             />
          )
          : null
       }
     </>
  );
}